
import { Box, Typography } from '@mui/material';

interface Props {
    label:  string;
    value:  string;
    color:  string;
}

export const ChipEstatus = ({ label, value, color }: Props) => {

    return (
        <Box
            sx={{
                display:        'flex',
                alignItems:     'stretch',
                height:         28,
                borderRadius:   '16px',
                overflow:       'hidden',
                border:         '1px solid',
                borderColor:    'divider',
            }}
        >

            <Box
                sx={{
                    display:        'flex',
                    alignItems:     'center',
                    px:             1.25,
                    bgcolor:        'grey.100',
                }}
            >
                <Typography variant='caption' fontWeight={500} color='primary' sx={{ fontSize: '0.85rem' }}>
                    { label }
                </Typography>
            </Box>

            <Box
                sx={{
                    display:        'flex',
                    alignItems:     'center',
                    px:             1.25,
                    bgcolor:        color,
                }}
            >
                <Typography variant='caption' fontWeight={600} sx={{ color: 'white', fontSize: '0.85rem' }}>
                    { value }
                </Typography>
            </Box>

        </Box>
    );

}
